<template>
    <div class="group flex items-center gap-4 p-4 sm:p-5 cursor-pointer hover:bg-brand-500/5 transition-colors">
        <div
            class="h-12 w-12 shrink-0 rounded-full overflow-hidden border border-app bg-brand-500/10 flex items-center justify-center">
            <img v-if="speaker.photoUrl" :src="speaker.photoUrl" :alt="speaker.name" class="h-full w-full object-cover" />
            <span v-else class="text-brand-500 font-black text-sm">{{ initials(speaker.name) }}</span>
        </div>
        <div class="min-w-0 flex-1">
            <h3 class="text-header font-bold leading-snug truncate">{{ speaker.name }}</h3>
            <p v-if="speaker.role || speaker.company" class="text-body/80 text-xs font-semibold truncate">
                {{ [speaker.role, speaker.company].filter(Boolean).join(' · ') }}
            </p>
        </div>
        <p v-if="speaker.topic" class="hidden md:block text-body text-sm max-w-xs text-right line-clamp-2 shrink-0">
            “{{ speaker.topic }}”</p>
    </div>
</template>

<script setup lang="ts">
import { EventSpeaker } from '~/types';
import { initials } from '../helpers';

defineProps<{ speaker: EventSpeaker }>();
</script>

<style scoped>
.border-app {
    border-color: rgb(var(--core-app-border));
}

.text-header {
    color: rgb(var(--core-header-text));
}

.text-muted {
    color: rgb(var(--core-muted-text));
}

.text-body {
    color: rgb(var(--core-body-text));
}
</style>
